import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
export function useStudioItem() {
    const { t } = useTranslation();
    const linkUrl = Url.studio();
    return {
        label: t('siteHeader.userMenu.myStudio'),
        link: linkUrl,
        biData: BiData({
            evid: 702,
            link_url: linkUrl,
            menu_item: 'my_studio',
            menu_name: 'profile'
        })
    };
}

//# sourceMappingURL=useStudioItem.js.map